<body class="external-page sb-l-c sb-r-c">


    <!-- Start: Main -->
    <div id="main" class="animated fadeIn">

        <!-- Start: Content-Wrapper -->
        <section id="content_wrapper">

            <!-- begin canvas animation bg -->
            <div id="canvas-wrapper">
                <canvas id="demo-canvas"></canvas>
            </div>

            <!-- Begin: Content -->
            <section id="content">

                <div class="admin-form theme-info" id="login1">

                    <div class="row mb15 table-layout">

                        <div class="col-xs-6 va-m pln">
                            <span title="Return to Dashboard">
                                <img src="assets/img/logolargo.png" title="AdminDesigns Logo" class="img-responsive w250">
                            </span>
                        </div>

                        <div class="col-xs-6 text-right va-b pr5">
                            <div class="login-links">

                                <a [routerLink]="['/register']" class="active" title="Register">Register</a>
                            </div>

                        </div>

                    </div>

                    <div class="panel panel-info mt10 br-n">
                        <div class="panel-heading heading-border ">
                            <!--  <div class="panel-heading heading-border bg-white">
                          <span class="panel-title hidden">
                           <i class="fa fa-sign-in"></i>Register</span>
                            <div class="section row mn">
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social facebook span-left mr5 btn-block">
                                        <span>
                                 <i class="fa fa-facebook"></i>
                                            </span>Facebook</a>
                                </div>
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social twitter span-left mr5 btn-block">
                                        <span>
                                              <i class="fa fa-twitter"></i>
                                            </span>Twitter</a>
                                </div>
                                <div class="col-sm-4">
                                    <a href="#" class="button btn-social googleplus span-left btn-block">
                                        <span>
                                    <i class="fa fa-google-plus"></i>
                                  </span>Google+</a>
                                </div>
                            </div> -->


                        </div>

                        <!-- end .form-header section -->
                        <form ngNativeValidate [formGroup]="forma" (ngSubmit)="ingresar()" method="post" id="contact">
                            <div class="panel-body bg-light p30">
                                <div class="row">
                                    <div class="col-sm-7 pr30">

                                        <div class="section">
                                            <label for="username" class="field-label text-muted fs18 mb10">Email</label>
                                            <label for="username" class="field prepend-icon">
                                            <input type="email" formControlName="email" name="email" id="email" class="gui-input" placeholder="Enter Email">
                                            <label for="username" class="field-icon">
                                              <i class="fa fa-user"></i>
                                            </label>
                                            </label>
                                            <div *ngIf="forma.controls['email'].invalid && forma.touched">
                                                <div class="alert alert-danger" role="alert">
                                                    You must write your Email
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end section -->

                                        <div class="section">
                                            <label for="username" class="field-label text-muted fs18 mb10">Password</label>
                                            <label for="password" class="field prepend-icon">
                                            <input type="password" formControlName="password" name="password" id="password" class="gui-input" placeholder="Enter password">
                                            <label for="password" class="field-icon">
                                              <i class="fa fa-lock"></i>
                                            </label>
                                            </label>
                                            <div *ngIf="forma.controls['password'].invalid && forma.touched">
                                                <div class="alert alert-danger" role="alert">
                                                    <p style="color:white"> You must write your Password </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end section -->



                                    </div>
                                    <div class="col-sm-5 br-l br-grey pl30">

                                      <br>
                                      <br>


                                    <div class="section row">
                                        <div class="col-md-12">
                                               <button type="button" (click)="onGoogle()" class="button btn-social googleplus span-left btn-block">
                                            <span>
                                              <i class="fa fa-google-plus"></i>
                                            </span>Google+</button>
                                        </div>
                                    </div>

                                    </div>


                                </div>
                            </div>



                            <!-- end .form-body section -->
                            <div class="panel-footer clearfix p10 ph15">
                                <button type="submit" [disabled]="!forma.valid" class="button btn-primary mr10 pull-right">Sign In</button>
                                <label class="switch ib switch-primary pull-left input-align mt10">
                              <input type="checkbox" formControlName="remember" name="remember" id="remember" checked>
                              <label for="remember" data-on="YES" data-off="NO"></label>
                                <span>Remember me</span>
                                </label>
                            </div>
                            <!-- end .form-footer section -->
                        </form>
                    </div>

                    <div class="version">
                      Version: {{version}}
                    </div>


                    <div class="logo">
                      <img class="img" src="assets/img/logoplay.png" />
                      <div class="linki">

                        <a style="text-decoration: none; cursor: pointer;" href="https://play.google.com/store/apps/details?id=com.transportappclient.transportapp" target="_blank">  <span class="tituloApp"> App Client </span>    </a>
                          |
                        <a style="text-decoration: none; cursor: pointer;" href="https://play.google.com/store/apps/details?id=com.transportappdriver.transportapp" target="_blank">    <span class="tituloApp"> App Driver </span>   </a>

                      </div>
                  </div>



                </div>





            </section>
            <!-- End: Content -->

        </section>
        <!-- End: Content-Wrapper -->

    </div>
    <!-- End: Main -->
</body>
